import { render, staticRenderFns } from "./ScheduledShipments.vue?vue&type=template&id=a4864db6"
import script from "./ScheduledShipments.vue?vue&type=script&lang=js"
export * from "./ScheduledShipments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports